import { IApplicationState } from '../../types/redux';
import { selectInfoForTgb } from './selectInfoForTgb';

export const selectNewbuidingsInfoForTgb = (state: IApplicationState) => selectInfoForTgb(state).jkInfoForTgbCollection;
